import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/microsoft-365-migration-readiness-check/ReadinessClient.tsx");
